import React from 'react';
import { Route, Switch } from 'react-router-dom';
import PrivateRoute from './privateRoute';
import Principal from '../components/principal';
import Login from '../components/login';
import Aop from '../components/aop';
import Anexo from '../components/anexo';
import Requerimento from '../components/requerimento';
import ListaRequerimentos from '../components/requerimentos';

const Routes = () => (
  <Switch>
    <Route exact path="/">
      <Principal />
    </Route>
    <Route path="/cadastro">
      <Aop />
    </Route>
    <Route path="/login">
      <Login />
    </Route>
    <PrivateRoute path="/anexo">
      <Anexo />
    </PrivateRoute>
    <PrivateRoute path="/requerimento">
      <Requerimento />
    </PrivateRoute>
    <PrivateRoute path="/requerimentos">
      <ListaRequerimentos />
    </PrivateRoute>

    {/* <Route path="/anexo">
      <Anexo />
    </Route> */}
  </Switch>
);

export default Routes;